"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var store_1 = require("./src/store");
exports.replaceRouterComponent = function (_ref) {
    var history = _ref.history;
    return function (_ref2) {
        var children = _ref2.children;
        return React.createElement(react_redux_1.Provider, { store: store_1.store }, React.createElement(react_router_dom_1.Router, { history: history }, children));
    };
};


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./gatsby-browser.tsx